<template>
  <div class="all">
    <div class="nav">
      <div class="left">
        <div class="title">营业点</div>
        <!-- <div class="btn" v-for="3" >1</div> -->
      </div>
      <div class="right">
        <el-button round size="medium" @click="getdashboard">自费早餐</el-button>
        <el-button round size="medium" @click="getMenuQuery">自费统计</el-button>
        <el-button round size="medium" @click="expense()">核销统计</el-button>
      </div>
    </div>
    <div class="content" v-if="type == 1">
      <div class="left">
        <div class="top">
          <div class="home">
            <el-input
              placeholder="输入会员卡号"
              ref="homeNumberInput"
              v-model="homeNumber"
              clearable
              @keyup.enter.native="handleScanEnter"
              @input="cleanCardNumber"
              @blur="validateCardLength"
            ></el-input>
            <!-- <el-button type="primary" round size="medium" class="reader" @click="readCard">读卡</el-button> -->
          </div>

          <!-- <el-button type="primary" round size="medium" v-if="!timer" @click="automatic" label="1">自动读卡</el-button>
          <el-button type="primary" round size="medium" v-if="timer" @click="noneautomatic" label="1">关闭读卡</el-button> -->
          <!-- <el-radio v-model="automatic" label="1">自动读卡</el-radio> -->
          <!--  <el-radio v-model="radio" label="2">自动核销</el-radio> -->
          <div class="btn-wrap">
            <el-checkbox v-model="automaticCalc" @change="changeAutoCalc">自动核销</el-checkbox>
            <el-button type="primary" round size="medium" icon="el-icon-search" @click="gethome" :disabled="automaticCalc">查询</el-button>
            <el-button type="warning" round class="btn2" @click="writeOffs('manual')" :disabled="automaticCalc">核销</el-button>
          </div>
        </div>
        <div class="boxs">
          <div class="box_text">
            <div>用餐总数</div>
            <div>
              {{ total }}
            </div>
          </div>
          <div class="box_text">
            <div>已用餐</div>
            <div>
              {{ writeOffCount }}
            </div>
          </div>
          <div class="box_text">
            <div>未用餐</div>
            <div>
              {{ unWriteOff }}
            </div>
          </div>
        </div>
        <div class="main">
          <div class="title">
            <div>客人信息</div>
          </div>

          <div class="table">
            <div class="label">
              <div class="tr">
                <div class="text">房号：</div>
                <div class="text" style="color: red">{{ writeOffInfo.roomNum }}</div>
              </div>
              <div class="tr">
                <div>含餐数量：{{ writeOffInfo.quantity }}</div>
              </div>

              <div class="tr">
                <div>已核销数量：{{ writeOffInfo.writeOffCount }}</div>
              </div>
              <div style="display: flex; justify-content: end">
                <div class="text">包价名称：</div>
                <div class="text" v-if="writeOffInfo.payOne">{{ writeOffInfo.setMealName }}</div>
              </div>
            </div>
            <div class="label">
              <div class="tr">
                <div class="text">姓名：</div>
                <div class="text">{{ writeOffInfo.custName }}</div>
              </div>
              <div class="tr">
                <div class="text">账号：</div>
                <div class="text">{{ writeOffInfo.memberAccountCode }}</div>
              </div>

              <div class="tr">
                <div class="text">是否有自付项：</div>
                <div class="text">{{ writeOffInfo.payOne ? '是' : '否' }}</div>
              </div>

              <div class="tr" style="justify-content: end" v-if="writeOffInfo.payTotal">
                <div class="text text_cost">自费：{{ writeOffInfo.payTotal }}元</div>
                <div class="text text_status">{{ writeOffInfo.writeOff == 'Y' ? '已结算' : '未结算' }}</div>
              </div>
            </div>

            <hr class="hr" />
            <div class="tr">
              <div class="text">到达：</div>
              <div class="text">{{ writeOffInfo.arriveTime }}</div>
            </div>
            <div class="tr">
              <div class="text">离开：</div>
              <div class="text">{{ writeOffInfo.leaveTime }}</div>
            </div>
            <hr class="hr" />
            <div class="tr">
              <div class="text">市场：</div>
              <div class="text">{{ writeOffInfo.msName }}</div>
            </div>
            <div class="tr">
              <div class="text">单位：</div>
              <div class="text">{{ writeOffInfo.groupName }}</div>
            </div>
            <div class="tr">
              <div class="text">团队：</div>
              <div class="text">{{ writeOffInfo.groupName }}</div>
            </div>
            <div class="tr">
              <div class="text">备注：</div>
              <div class="text">{{ writeOffInfo.remark }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="top">
          <div>核销记录</div>
          <div>合计：{{ allTotal }}条</div>
        </div>
        <div>
          <el-table :data="tableData" stripe style="width: 100%">
            <el-table-column prop="writeOffCount" label="数量" width="50"></el-table-column>
            <el-table-column prop="totalPrice" label="金额">
              <template slot-scope="scope">
                {{ scope.row.totalPrice.toFixed(2) }}
              </template>
            </el-table-column>
            <el-table-column prop="roomNum" label="房号"></el-table-column>
            <el-table-column prop="accountCode" label="账号" width="120"></el-table-column>
            <el-table-column prop="productName" label="项目"></el-table-column>
            <el-table-column prop="writeOffTime" show-overflow-tooltip label="时间"></el-table-column>
            <el-table-column prop="empName" label="核销工号"></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button v-if="scope.row.status == 'O'" @click="cancel(scope.row)" :Loading="Loading" type="text" size="small">撤销核销</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <div class="expense" v-if="type == 3">
      <div class="flex_wrap">
        <div class="flex_box_center">
          <span>开始日期&nbsp;&nbsp;</span>
          <el-date-picker v-model="query.startTime" :picker-options="pickerOptionsStart" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" style="width: 68%"></el-date-picker>
        </div>

        <div class="flex_box_center">
          &nbsp;&nbsp;
          <span>结束日期&nbsp;&nbsp;</span>
          <el-date-picker v-model="query.endTime" :picker-options="pickerOptionsEnd" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" style="width: 68%"></el-date-picker>
        </div>

        <div class="flex_box_center">
          &nbsp;&nbsp;
          <span>工号&nbsp;&nbsp;</span>
          <el-select clearable v-model="query.userId" style="width: 68%">
            <el-option :value="undefined" label="所有"></el-option>
            <el-option v-for="item in options" :key="item.user_id" :label="item.name" :value="item.user_id"></el-option>
          </el-select>
        </div>
        <div style="margin: 6px 10px; min-width: 200px; text-align: right; font-size: 14px">
          <el-button style="margin: 6px 10px" size="small" @click="hanleQuery" type="primary">查询</el-button>
          <el-button type="primary" size="small" @click="todoPrint('print')">打印</el-button>
          <el-button type="primary" size="small" @click="todoPrint('preview')">打印预览</el-button>
          <el-button type="primary" size="small" @click="todoExport">导出</el-button>
        </div>
      </div>
      <div v-loading="loading">
        <div ref="tablePrint" class="print">
          <div style="margin-top: 10px; height: 650px; overflow: auto">
            <div id="tablePrint">
              <verificationTable :listQuery="query" :tabelList="tabelList" :sumsTotal="sumsTotal"></verificationTable>
            </div>
          </div>
        </div>
        <div ref="tablePrintExport" class="Export_table" v-show="false">
          <div style="margin-top: 10px; height: 650px; overflow: auto">
            <div id="tablePrintExport">
              <verificationTable :listQuery="query" :exportShow="true" :sumsTotal="sumsTotal" :tabelList="tabelList"></verificationTable>
            </div>
          </div>
        </div>
        <div id="copy_div" v-show="false" style="'width:100%'" class="'flex-seting'"></div>
      </div>
    </div>
  </div>
</template>
<script>
import DateUtils from '@/utils/DateUtils';
import verificationTable from './verificationTable';
import getLodop from '../../utils/Lodopfuncs';

export default {
  components: {
    verificationTable,
  },
  name: 'breakfast',
  data() {
    return {
      timer: null,
      home: '',
      Loading: false,
      loading: false,
      tableData: [],
      homeList: [
        {
          quantity: null,
          room_num: null,
          code: null,
          leave_time: null,
          msName: null,
          setMealName: null,
          name_: null,
          arrive_time: null,
          remark: null,
          corpName: null,
          group_name: null,
          writeOffCount: null,
          cirId: null,
        },
      ],
      quantity: 0, //早餐数量
      writeOffCounts: 0, //核销数量
      allTotal: 0, //总数量
      peopleCount: 0,
      roomCount: 0,
      writeOffCount: 0,
      unWriteOff: 0, //未用早餐数量
      total: 0,
      homeNumber: '',
      managerLock: '',
      type: 1,
      options: [],
      outletsListArr: [],
      bookByOutletsArr: [],
      foodTypeByBooksArr: [],
      query: {
        userId: '',
        startTime: DateUtils.formatDate(new Date(), 'yyyy-MM-dd'),
        endTime: DateUtils.formatDate(new Date(), 'yyyy-MM-dd'),
      },
      tabelList: [],
      sumsTotal: {
        quantity: 0,
        write_off_count: 0,
      },
      pickerOptionsStart: {
        disabledDate: time => {
          let delay = this.query.endTime;
          if (delay) {
            return time.getTime() > new Date(delay).getTime();
          }
        },
      },
      pickerOptionsEnd: {
        disabledDate: time => {
          let delay = this.query.startTime;
          if (delay) {
            return time.getTime() < new Date(delay).getTime() - 3600 * 1000 * 24;
          }
        },
      },
      automaticCalc: false,
      writeOffInfo: {}, //核销信息
      isProcessing: false, //防止重复调用
    };
  },
  created() {
    this.statistics();
    this.lockCodes();
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  watch: {
    automaticCalc(val) {
      if (!this.isProcessing && val && this.homeNumber) {
        this.writeOffs('scan');
      }
    },
    homeNumber(val) {
      if (!this.isProcessing && val && this.automaticCalc) {
        this.writeOffs('scan');
      }
    },
  },
  methods: {
    isValidCardLength(cardNo) {
      const len = cardNo ? String(cardNo).length : 0;
      return len === 32 || len === 34;
    },
    validateCardLength() {
      if (!this.homeNumber) return;
      const valid = this.isValidCardLength(this.homeNumber);
      if (!valid) {
        this.$message.error('卡号长度不正确，请确认后重新输入');
      }
    },
    statistics() {
      let url = this.api.statistics;
      let methods = 'get';
      let data = {
        businessDate: localStorage.getItem('businessDate'),
      };
      this.$axios({
        url,
        methods,
        data,
      }).then(res => {
        console.log(res);
        if (!res.data.status) {
          this.peopleCount = res.data.data.peopleCount;
          this.roomCount = res.data.data.roomCount;
          this.writeOffCount = res.data.data.writeOffCount;
          this.unWriteOff = res.data.data.unWriteOff;
          this.total = res.data.data.total;
        }
      });
    },
    cleanCardNumber() {
      this.homeNumber = this.homeNumber.replace(/[\r\n\s\t]/g, '');
    },
    handleScanEnter() {
      if (!this.homeNumber) {
        this.$message.warning('请输入会员卡号');
        return;
      }
      this.validateCardLength();
    },
    changeAutoCalc(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.homeNumberInput.focus();
        });
      }
    },
    gethome() {
      if (!this.homeNumber) {
        this.$message({
          message: '请先读卡',
          type: 'warning',
        });
        return;
      }
      if (!this.isValidCardLength(this.homeNumber)) {
        return;
      }
      let url = this.api.getWriteInfo;
      let methods = 'get';
      let data = {
        memberInfoId: this.homeNumber,
      };
      this.Loading = true;
      this.$axios({
        url,
        methods,
        data,
      })
        .then(res => {
          this.Loading = false;
          if (res.data.code == 0) {
            this.writeOffInfo = res.data.data;
          }
        })
        .catch(err => {
          this.Loading = false;
          console.log(err);
        });
    },
    getList() {
      let url = this.api.writeOffList;
      let methods = 'get';
      if (this.homeList.length < 1) {
        this.tableData = [];
        this.allTotal = 0;
        return;
      }
      this.Loading = true;
      this.$axios({
        url,
        methods,
      })
        .then(res => {
          this.Loading = false;
          this.tableData = res.data.data;
          this.allTotal = 0;
          res.data.data.forEach(res => {
            if (res.status == 'O') {
              this.allTotal += res.writeOffCount;
            }
          });
          console.log(res);
        })
        .catch(err => {
          this.Loading = false;
        });
    },
    // 读卡类型
    lockCodes() {
      let url = this.api.lockCode;
      let methods = 'get';

      this.Loading = true;
      this.$axios({
        url,
        methods,
      }).then(res => {
        if (res.data.status == 0) {
          this.managerLock = res.data.data ? res.data.data : '';
          console.log('lockCode', res.data.data, this.managerLock);
        }
      });
    },
    automatic() {
      this.timer = setInterval(() => {
        console.log('开始---');
        this.readCard();
      }, 1000);
    },
    noneautomatic() {
      clearInterval(this.timer);
      this.timer = null;
    },
    readCard() {
      if (this.managerLock == 'bd') {
        this.readCard1();
      } else if (this.managerLock == 'yg') {
        this.readCard2();
      } else {
        this.$message({
          message: '该酒店未设置门锁接口',
          type: 'error',
        });
      }
    },
    //必达读卡
    readCard1() {
      let url = 'http://127.0.0.1:18833/betech/api/v1/hotel/key/check';
      this.$http.jsonp(url).then(res => {
        // console.log(res.data);
        console.log('必达读卡接口', url, res.data);
        if (res.data.code == 0) {
          this.homeNumber = res.data.detail.card_no;
          this.gethome();
          this.$message({
            message: '读卡成功',
            type: 'success',
            center: true,
          });
        } else {
          this.BDdebug(res.data.code);
        }
      });
    },
    //读卡
    readCard2() {
      //门锁包读卡
      let url = this.api.readCard;
      let methods = 'get';

      this.Loading = true;
      this.$axios({
        url,
        methods,
      }).then(res => {
        if (res.data.status == 1) {
          this.$message({
            message: '读卡成功',
            type: 'success',
            center: true,
          });
          this.homeNumber = res.data.data.cardSnr;
          this.gethome();
        } else {
          this.debug(res.data.status);
        }
      });
    },
    //制卡包报错信息
    debug(index) {
      let msg;
      switch (index) {
        case -1:
          msg = '没检测到卡片';
        case -2:
          msg = '没检测到读卡器';
        case -3:
          msg = '无效卡';
        case -5:
          msg = '读写错误';
        case -6:
          msg = '端口未打开';
        case -7:
          msg = '数据卡结束';
        case -8:
          msg = '无效参数';
        case -9:
          msg = '无效操作';
        case -10:
          msg = '其它错误';
        case -11:
          msg = '端口已被占用';
        case -12:
          msg = '通讯错误';
        case -20:
          msg = '客户码错误';
        case -29:
          msg = '未注册';
        case -30:
          msg = '无授权卡信息';
        case -31:
          msg = '房数超出了可用扇区';
        case -404:
          msg = '动态加载失败';
        case -99:
          msg = '其他报错';
        case -409:
          msg = '没有对应接口';
      }
      this.$message({
        message: msg,
        type: 'error',
        center: true,
      });
    },
    //必达制卡包报错信息
    BDdebug(index) {
      let msg;
      switch (index) {
        case 255:
          msg = '请求失败';
        case 1:
          msg = '打开串口错误';
        case 2:
          msg = '无卡错误';
        case 3:
          msg = '卡类型错误';
        case 4:
          msg = '读卡错误';
        case 5:
          msg = '酒店密码错误';
        case 6:
          msg = '写卡错误';
        case 7:
          msg = '数据库连接失败';
        case 8:
          msg = '房间代号不存在';
        case 9:
          msg = '房卡与房号错误';
        case 14:
          msg = '该卡不是客人卡';
        case 15:
          msg = '该卡不是无效卡，未制过卡';
        case 21:
          msg = '发卡器类型错误';
        case 22:
          msg = '连接发卡器失败';
        case 24:
          msg = '卡类型错误';
        case 23:
          msg = '无法识别的卡类型';
        case 25:
          msg = '参数错误';
        case 32:
          msg = '门锁对照号不存在';
      }
      this.$message({
        message: msg,
        type: 'error',
        center: true,
      });
    },
    expense() {
      console.log(this.type);
      if (this.type == 1) {
        this.type = 3;
        this.hanleQuery();
        this.getEmpLists();
      } else {
        this.type = 1;
        this.homeNumber = '';
        this.tableData = [];
        (this.homeList = [
          {
            quantity: null,
            room_num: null,
            code: null,
            leave_time: null,
            msName: null,
            setMealName: null,
            name_: null,
            arrive_time: null,
            remark: null,
            corpName: null,
            group_name: null,
            writeOffCount: null,
            cirId: null,
          },
        ]),
          (this.allTotal = 0);
      }
    },
    getEmpLists() {
      //获取操作员工

      let url = this.api.getListMap,
        methods = 'get';
      this.$axios({
        url,
        methods,
      }).then(response => {
        if (response.data.status === 0) {
          this.options = response.data.data;
        }
      });
      // 控制营业点
      url = this.api.getoutlets;
      let data = {
        posCode: localStorage.getItem('posCode'),
      };
      this.$axios({
        url,
        methods,
        data,
      }).then(res => {
        if (res.data.status === 0) {
          this.outletsListArr = res.data.data;
        }
      });
      url = this.api.bookByOutlets;
      this.$axios({
        url,
        methods,
      }).then(res => {
        if (res.data.status === 0) {
          this.bookByOutletsArr = res.data.data;
        }
      });

      url = this.api.foodTypeByBooks;
      this.$axios({
        url,
        methods,
      }).then(res => {
        if (res.data.status === 0) {
          this.foodTypeByBooksArr = res.data.data;
        }
      });
    },
    writeOffs(source) {
      if (this.isProcessing) return; // 正在处理中，直接返回
      this.isProcessing = true;
      this.writeOffInfo = {};
      if (!this.homeNumber) {
        this.$message({
          message: '请先输入会员卡号',
          type: 'warning',
        });
        this.isProcessing = false;
        return;
      }
      if (!this.isValidCardLength(this.homeNumber)) {
        // this.$message({ message: '卡号长度必须为32位或34位', type: 'error' });
        this.isProcessing = false;
        return;
      }
      let url = this.api.writeOff;
      let methods = 'get';
      let data = {
        memberInfoId: this.homeNumber,
      };
      this.Loading = true;
      this.$axios({
        url,
        methods,
        data,
      })
        .then(async res => {
          if (res.data.status === 0) {
            this.Loading = false;
            this.writeOffInfo = res.data.data;
            this.$message({
              message: '核销成功',
              type: 'success',
            });
            await this.statistics();
            await this.getList();
          } else {
            this.writeOffInfo = {};
          }
        })
        .catch(err => {
          this.Loading = false;
        })
        .finally(() => {
          this.isProcessing = false;
          // 自动核销清空输入框内容
          if (source === 'scan') {
            this.homeNumber = '';
            this.$nextTick(() => {
              this.$refs.homeNumberInput.focus();
            });
          }
        });
    },
    cancel(row) {
      let url = this.api.writeCancel;
      let methods = 'get';
      let data = {
        id: row.id,
      };
      this.Loading = true;
      this.$axios({
        url,
        methods,
        data,
      })
        .then(res => {
          this.Loading = false;
          if (res.data.status == 0) {
            this.gethome();
            // this.getList()
            this.statistics();
            this.$message({
              message: '撤销成功',
              type: 'success',
            });
          }
        })
        .catch(() => {
          this.Loading = false;
        });
    },
    hanleQuery() {
      let url = this.api.statisticsReport;
      let methods = 'get';
      let data = this.query;
      this.Loading = true;
      this.$axios({
        url,
        methods,
        data,
      })
        .then(res => {
          this.Loading = false;
          if (res.data.status == 0) {
            this.tabelList = res.data.data;
            this.sumsTotal.quantity = 0;
            this.sumsTotal.write_off_count = 0;
            res.data.data.forEach(item => {
              this.sumsTotal.quantity += item.quantity;
              this.sumsTotal.write_off_count += item.write_off_count;
            });
          }
        })
        .catch(() => {
          this.Loading = false;
        });
    },
    todoPrint(type) {
      const LODOP = getLodop();
      // 获取大小和宽度
      let printSize = 12;
      let width = 2;
      if (LODOP) {
        // 判断是否是数字
        let falg = false;
        if (document.getElementById('tablePrint')) {
          document.getElementById('copy_div').innerHTML = '';
          let innerHTML = document.getElementById('tablePrint').cloneNode(true);
          innerHTML.style.border = 'none';
          innerHTML.style.borderCollapse = 'collapse';
          innerHTML.style.fontSize = printSize + 'px';
          document.getElementById('copy_div').appendChild(innerHTML);
          falg = true;
        }
        this.$nextTick(() => {
          var strFormHtml =
            `
                <body >` +
            document.getElementById(falg ? 'copy_div' : 'tablePrint').innerHTML +
            '</body>'; //获取打印内容
          LODOP.PRINT_INIT(''); //初始化
          LODOP.SET_PRINT_PAGESIZE(1, 0, 0, 'A4'); //设置纵向
          LODOP.ADD_PRINT_TABLE('2%', width + '%', 100 - width * 2 + '%', '88%', strFormHtml);
          LODOP.SET_PRINT_STYLEA(0, 'Offset2Top', -100);
          LODOP.SET_PRINT_STYLEA(0, 'LetterSpacing', 0);
          LODOP.SET_PREVIEW_WINDOW(2, 0, 0, 800, 600, ''); //设置预览窗口模式和大小
          LODOP.ADD_PRINT_TEXT(566, 542, 165, 22, '第#页/共&页');
          LODOP.SET_PRINT_STYLEA(0, 'ItemType', 2);
          LODOP.SET_PRINT_STYLEA(0, 'Horient', 2);
          LODOP.SET_PRINT_STYLEA(0, 'Vorient', 1);
          if (type === 'preview') {
            LODOP.PREVIEW();
          } else {
            LODOP.PRINT();
          }
        });
      }
    },
    todoExport() {
      var LODOP = getLodop();
      LODOP.PRINT_INIT('');
      LODOP.ADD_PRINT_TABLE(5, 5, '99%', '100%', document.getElementById('tablePrintExport').innerHTML);
      //LODOP.SET_SAVE_MODE("QUICK_SAVE",true);//快速生成（无表格样式,数据量较大时或许用到）
      LODOP.SAVE_TO_FILE('早餐核销统计.xls');
    },
    getMenuQuery() {
      this.$bus.$emit('MenuQuery', 1);
    },
    getdashboard() {
      this.$bus.$emit('dashboard', 1);
    },
  },
};
</script>
<style lang="scss" scoped>
.all {
  background: #fff;
  min-height: calc(100vh - 80px);
  width: 100%;
}

.nav {
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  border-bottom: 1px solid #eee;
}

.content {
  display: grid;
  grid-template-columns: 55% 45%;
  align-items: stretch;
  height: calc(100% - 70px);
  overflow-y: auto;
  font-size: 14px;

  .left {
    // padding: 20px;
    border-right: 1px solid #eee;

    .top {
      display: flex;
      // justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #eee;
      padding: 0 20px;
      height: 60px;

      .home {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 400px;
        margin-right: 10px;

        .reader {
          margin-left: 10px;
        }
      }
      .btn-wrap {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 20px;
      }
    }

    .boxs {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      grid-row-gap: 20px;
      grid-column-gap: 120px;
      padding: 20px;
      margin: 10px;
      border: 1px solid #eee;
      border-radius: 6px;

      .box_text {
        background: #3370ff;
        color: #fff;
        font-size: 16px;
        text-align: center;
        display: grid;
        grid-template-rows: 1fr 1fr;
        grid-row-gap: 10px;
        padding-top: 20px;
        padding-bottom: 20px;
        border-radius: 10px;
      }
    }

    .main {
      // padding: 20px;
      margin: 10px;
      border: 1px solid #eee;
      border-radius: 6px;
      font-weight: 500;

      .title {
        height: 40px;
        line-height: 40px;
        padding-left: 10px;
        border-bottom: 1px solid #eee;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-right: 20px;
      }

      .table {
        padding: 20px;

        .label {
          display: grid;
          align-items: center;
          grid-template-columns: 1fr 1fr 1fr 1fr;
          margin: 10px 0;
        }

        .tr {
          display: flex;

          align-items: center;
          height: 30px;
          line-height: 30px;
        }

        .hr {
          color: #eee;
          background-color: #eee;
          height: 1px;
          border: none;
        }
        .text_cost {
          background: #409eff;
          color: #fff;
          padding: 2px 8px;
          border-top-left-radius: 6px;
          border-bottom-left-radius: 6px;
        }
        .text_status {
          background: #dcdfe6;
          color: red;
          padding: 2px 8px;
          border-top-right-radius: 6px;
          border-bottom-right-radius: 6px;
        }
      }
    }
  }

  .right {
    .top {
      display: flex;
      justify-content: space-between;
      height: 60px;
      line-height: 40px;
      padding: 0 20px;
      align-items: center;
      border-bottom: 1px solid #eee;
    }
  }
}

.btn1 {
  color: #fff;
  background: #3370ff;
  border-radius: 20px;
  padding: 0px 8px;
  margin-left: 10px;
  font-size: 12px;
  width: 60px;
  height: 30px;
  line-height: 30px;
  text-align: center;
}

.btn2 {
  height: 36px;
  line-height: 36px;
  color: #fff;
  padding: 0px 8px;
  margin-left: 10px;
  font-size: 15px;
  width: 89px;
  text-align: center;
}

.flex_wrap {
  flex-wrap: nowrap;
  margin-top: 10px;
}

.flex_box_center {
  font-size: 14px;
}

.print {
  padding: 0 20px;
}
</style>
